var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SidePanel", {
    on: { close: _vm.close },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("h3", { staticClass: "mt-0 clearfix" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Service email")) +
                  "\n        "
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("div", { staticClass: "page-emailBox" }, [
              _c(
                "div",
                {
                  staticClass:
                    "placeholder placeholder-small well error py-6 b-0"
                },
                [
                  _c("h3", { staticClass: "mb-3" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Il semblerait que nous rencontrions un problème avec votre compte email"
                          )
                        ) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-medium-bold" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Votre compte email n’est plus correctement synchronisé."
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Nous vous invitons à déconnecter puis à reconnecter votre compte email depuis les paramètres des emails."
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-medium-bold" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Vous devez ensuite attendre quelques minutes pour vous assurer que la synchronisation soit effective."
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "acenter mt-4" },
                    [
                      _c("CompassLink", {
                        attrs: {
                          link: "/?_f=emailPreferences&action=emailsParams",
                          label: _vm.localizedTexts.linkError
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }